<script>
import {
	defineComponent,
	onMounted,
} from 'vue';

import EcommerceProductPreview from '@zyro-inc/site-modules/components/ecommerce/modals/EcommerceProductPreview.vue';
import EcommerceBookingEventSelect from '@zyro-inc/site-modules/components/ecommerce/modals/EcommerceBookingEventSelect.vue';
import EcommerceBookingUnavailable from '@zyro-inc/site-modules/components/ecommerce/modals/EcommerceBookingUnavailable.vue';
import EcommerceCheckoutFailed from '@zyro-inc/site-modules/components/ecommerce/modals/EcommerceCheckoutFailed.vue';
import EcommerceCheckoutSuccess from '@zyro-inc/site-modules/components/ecommerce/modals/EcommerceCheckoutSuccess.vue';
import EcommerceMessageButtonDisabled from '@zyro-inc/site-modules/components/ecommerce/modals/EcommerceMessageButtonDisabled.vue';
import EcommerceOutOfStock from '@zyro-inc/site-modules/components/ecommerce/modals/EcommerceOutOfStock.vue';
import EcommerceOutdatedCartItem from '@zyro-inc/site-modules/components/ecommerce/modals/EcommerceOutdatedCartItem.vue';
import EcommerceSubmitReviewModal from '@zyro-inc/site-modules/components/ecommerce/modals/EcommerceSubmitReviewModal.vue';
import { useEcommerceModal } from '@zyro-inc/site-modules/components/ecommerce/modals/useEcommerceModal';

const OPEN_MODAL_QUERY_PARAM = 'open-modal';

export default defineComponent({
	components: {
		EcommerceProductPreview,
		EcommerceBookingEventSelect,
		EcommerceBookingUnavailable,
		EcommerceCheckoutFailed,
		EcommerceCheckoutSuccess,
		EcommerceMessageButtonDisabled,
		EcommerceOutOfStock,
		EcommerceSubmitReviewModal,
		EcommerceOutdatedCartItem,
	},

	props: {
		ecommerceTranslations: {
			type: Object,
			default: () => ({}),
		},
		language: {
			type: String,
			default: 'en',
		},
		currentLocale: {
			type: String,
			required: true,
		},
		isCartVisible: {
			type: Boolean,
			default: false,
		},
		isInPreviewMode: {
			type: Boolean,
			default: false,
		},
	},

	setup() {
		const {
			openEcommerceModal,
			closeEcommerceModal,
			openEcommerceModalName,
		} = useEcommerceModal();

		onMounted(() => {
			const params = new URLSearchParams(window.location.search);
			const queryModalName = params.get(OPEN_MODAL_QUERY_PARAM);

			if (queryModalName) {
				openEcommerceModal(queryModalName);
			}
		});

		return {
			openEcommerceModal,
			closeEcommerceModal,
			openEcommerceModalName,
		};
	},
});
</script>

<template>
	<Component
		:is="openEcommerceModalName"
		v-if="openEcommerceModalName"
		:translations="ecommerceTranslations"
		:language="language"
		:current-locale="currentLocale"
		:is-cart-visible="isCartVisible"
		:is-in-preview-mode="isInPreviewMode"
		is-quick-preview
	/>
</template>
